import { CodedDocumentKey } from './trip';

/** The trip page's form (#5790). */
export interface TripFormModel {
  employee: CodedDocumentKey | null;
  destination: string;
  departureDate: Date | null;
  returnDate: Date | null;
  purpose: string;
  costCenterReference: string | null;
  claimPolicyReference: string | null;
}

export const tripFieldLabels: Record<keyof TripFormModel, string> = {
  employee: 'Trip_Field_Employee',
  destination: 'Trip_Field_Destination',
  departureDate: 'Trip_Field_Departure',
  returnDate: 'Trip_Field_Return',
  purpose: 'Trip_Field_Purpose',
  costCenterReference: 'Trip_Field_CostCenter',
  claimPolicyReference: 'Trip_Field_ClaimPolicy',
};
